import { Controller } from '@hotwired/stimulus'

// Visibility/UI only (not validation): one instance per input (span.position-relative). Toggles the
// `custom-speed-cons` highlight + erase-to-default button when a value differs from its hidden default.
// Uses only targets, no querySelector.
export default class extends Controller {
  static targets = ['input', 'default', 'eraseButton']

  connect() {
    this.updateVisibility()
  }

  restoreDefault() {
    if (!this.hasDefaultTarget) return
    this.inputTarget.value = this.defaultTarget.value
    // speeds-consumption's submission-gating listens only to 'input', not 'change', so dispatch both.
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  updateVisibility() {
    if (!this.hasInputTarget || !this.hasEraseButtonTarget) return
    const defaultValue = this.hasDefaultTarget ? this.defaultTarget.value : ''
    const currentValue = this.inputTarget.value
    const isCustom = defaultValue !== '' && defaultValue !== undefined && currentValue !== defaultValue
    if (isCustom) {
      this.inputTarget.classList.add('custom-speed-cons')
      this.eraseButtonTarget.style.display = ''
    } else {
      this.inputTarget.classList.remove('custom-speed-cons')
      this.eraseButtonTarget.style.display = 'none'
    }
  }
}
